var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFHanche2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 178,
    viewBox: "0 0 104 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.2752 0.0991211C90.2152 20.1493 80.5918 51.8393 86.547 70.1736C92.5022 88.5079 93.6237 97.0569 93.978 111.294C94.3323 125.531 90.911 148.996 89.1614 177.099",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9561 72.0044C94.9561 72.0044 107.695 90.2006 100.786 136.181",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06435 0.0991211C13.1244 20.1493 22.7478 51.8393 16.7926 70.1736C10.8374 88.5079 9.71587 97.0569 9.36158 111.294C9.0073 125.531 12.4286 148.996 14.1782 177.099",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38354 72.0044C8.38354 72.0044 -4.35557 90.2006 2.55357 136.181",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFHanche2);
export default __webpack_public_path__ + "static/media/F-HANCHE_2.c437d4fed6559a436f2deca684586eed.svg";
export { ForwardRef as ReactComponent };